import { AlertCircleIcon, ArchiveIcon, ClockIcon } from '@orn/shared-web/icons';
import { cx } from '@orn/shared-web/utils/cx';
import * as React from 'react';

import { ALERT_SECTION_LABELS } from '../../utils/alerts';

import type { AlertStatusSection } from '../../utils/alerts';

const ICON_BY_SECTION: Record<AlertStatusSection, React.ComponentType<{ className?: string }>> = {
  needAttention: AlertCircleIcon,
  pending: ClockIcon,
  history: ArchiveIcon,
};

interface IAlertSectionProps {
  section: AlertStatusSection;
  /**
   * Total alerts in this status group — the per-status count query, not the
   * number of rows passed in. Paginated sections show more here than on screen.
   */
  count: number;
  /** The rows themselves, typically `AlertListItem` elements. */
  children: React.ReactNode;
  className?: string;
}

/**
 * One status group of the Alerts Center: a labeled header with the group's
 * total, above the rows it was handed. Always expanded. Renders whatever it is
 * given, so callers drop the sections they have no rows for.
 */
const AlertSection = ({ section, count, children, className }: IAlertSectionProps) => {
  const Icon = ICON_BY_SECTION[section];

  return (
    <div className={cx('flex flex-col', className)}>
      <div className="border-secondary text-secondary flex items-center gap-1.5 border-b py-2 text-xs font-medium uppercase">
        <Icon className="size-3.5 shrink-0" />
        <span>
          {ALERT_SECTION_LABELS[section]} ({count})
        </span>
      </div>
      <div className="flex flex-col gap-2 pt-3">{children}</div>
    </div>
  );
};

export default AlertSection;
